<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            :title="isCreate ? 'CREATE QC TEST' : 'UPDATE QC TEST'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">
          <div class="vx-row mb-3" v-if="['powder', 'liquid', 'fruit'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="odour" name="odour" rules="" v-slot="{ errors }">
                <small class="label">
                  Odour <span v-if="q_c_quide.odour" class="qc-test-guide-text">(Guide: {{ q_c_quide.odour }})</span>
                </small>
                <vs-input v-model="form.odour"  name="odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['powder', 'liquid', 'fruit'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="appearance" name="appearance" rules="" v-slot="{ errors }">
                <small class="label">
                  Appearance <span v-if="q_c_quide.appearance_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.appearance_from }} - {{ q_c_quide.appearance_to }})</span>
                </small>
                <vs-input v-model="form.appearance"  name="appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['powder'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="moisture" name="moisture" rules="" v-slot="{ errors }">
                <small class="label">
                  Moisture <span v-if="q_c_quide.moisture" class="qc-test-guide-text">(Guide: {{ q_c_quide.moisture }})</span>
                </small>
                <vs-input v-model="form.moisture"  name="moisture" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['powder', 'liquid', 'fruit'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="taste" name="taste" rules="" v-slot="{ errors }">
                <small class="label">
                  Taste <span v-if="q_c_quide.taste" class="qc-test-guide-text">(Guide: {{ q_c_quide.taste }})</span>
                </small>
                <vs-input v-model="form.taste"  name="taste" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['liquid'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="specific_gravity_20" name="specific_gravity_20" rules="" v-slot="{ errors }">
                <small class="label">
                  SG @ 20 degrees C. <span v-if="q_c_quide.sg_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.sg_from }}-{{ q_c_quide.sg_to }})</span>
                </small>
                <vs-input v-model="form.specific_gravity_20"  name="specific_gravity_20" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                  @input="generateErrors()"/>
                  <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'specific_gravity_20')">You have SG results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['liquid'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="ph" name="ph" rules="ph_value" v-slot="{ errors }">
                <small class="label">
                  pH <span v-if="q_c_quide.ph_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.ph_from }}-{{ q_c_quide.ph_to }})</span>
                </small>
                <vs-input v-model="form.ph"  name="ph" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                @input="generateErrors()"/>
                <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'ph')">You have pH results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="['liquid'].includes(formulation_type)">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="refractive_index_20" name="refractive_index_20" rules="" v-slot="{ errors }">
                <small class="label">
                  RI @ 20 degrees C. <span v-if="q_c_quide.ri_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.ri_from }}-{{ q_c_quide.ri_to }})</span>
                </small>
                <vs-input v-model="form.refractive_index_20"  name="refractive_index_20" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                @input="generateErrors()"/>
                <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'refractive_index_20')">You have RI results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="brix" name="brix" rules="" v-slot="{ errors }">
                <small class="label">
                  Brix <span v-if="q_c_quide.brix_from" class="qc-test-guide-text">(Guide: {{ q_c_quide.brix_from }}-{{ q_c_quide.brix_to }})</span>
                </small>
                <vs-input v-model="form.brix"  name="brix" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                @input="generateErrors()"/>
                <span class="text-danger text-sm" v-if="validations_errors.find((x) => x.field === 'brix')">You have brix results outside specification - these cannot be QC passed</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="q_c_status" name="q_c_status" rules="required" v-slot="{ errors }">
                <small class="label">Status</small>
                <v-select :clearable="true" name="q_c_status" placeholder="" v-model="form.status" label="name" :reduce="option => option.value"
                          :options="[{name: 'Approved by QC', value:'approved'}, {name: 'Rejected by QC', value: 'rejected'}]" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div v-if="form.status === 'rejected'">

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="unacceptable_standards" name="unacceptable_standards" rules="required" v-slot="{ errors }">
                  <small class="label">Reason for rejection</small>
                  <vs-input v-model="form.rejected_data.unacceptable_standards"  name="unacceptable_standards" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="check_batch_quantity" name="check_batch_quantity" rules="required" v-slot="{ errors }">
                  <small class="label">Check Batch Quantity</small>
                  <vs-switch v-model="form.rejected_data.action[0].check_batch_quantity" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_check_batch_quantity" name="action_by_production_check_batch_quantity"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[0].action_by_production"  name="action_by_production_check_batch_quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Re Sample</small>
                  <vs-switch v-model="form.rejected_data.action[1].re_sample" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_re_sample" name="action_by_production_re_sample"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[1].action_by_production"  name="action_by_production_re_sample" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="re_stir" name="re_stir" rules="required" v-slot="{ errors }">
                  <small class="label">Restir</small>
                  <vs-switch v-model="form.rejected_data.action[2].re_stir" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_re_stir" name="action_by_production_re_stir"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[2].action_by_production"  name="action_by_production_re_stir" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="re_filter" name="re_filter" rules="required" v-slot="{ errors }">
                  <small class="label">Refilter</small>
                  <vs-switch v-model="form.rejected_data.action[3].re_filter" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_re_filter" name="action_by_production_re_filter"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[3].action_by_production"  name="action_by_production_re_filter" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="re_pack" name="re_pack" rules="required" v-slot="{ errors }">
                  <small class="label">Repack</small>
                  <vs-switch v-model="form.rejected_data.action[4].re_pack" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_re_pack" name="action_by_production_re_pack"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[4].action_by_production"  name="action_by_production_re_pack" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="other" name="other"
                                    v-slot="{ errors }">
                  <small class="label">Other</small>
                  <vs-input v-model="form.rejected_data.action[5].other"  name="other" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="action_by_production_other" name="action_by_production_other"
                                    v-slot="{ errors }">
                  <small class="label">Action By Production</small>
                  <vs-input v-model="form.rejected_data.action[5].action_by_production"  name="action_by_production_other" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="form.status === 'approved' && validations_errors.length  > 0" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const FormulationRepository = RepositoryFactory.get('formulations');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  function initialState() {
    return {
      open: false,
      id: '',
      formulation_type: '',
      formulation_id: '',
      q_c_quide: {},
      form: {
        notes: '',
        status: '',
        rejected_data: {
          unacceptable_standards: '',
          action: [
            { check_batch_quantity: false, action_by_production: '' },
            { re_sample: false, action_by_production: '' },
            { re_stir: false, action_by_production: ''},
            { re_filter: false, action_by_production: '' },
            { re_pack: false, action_by_production: '' },
            { other: '', action_by_production: ''}
          ],
        }
      },
      rejected_data: {
        unacceptable_standards: '',
        action: [
          { check_batch_quantity: false, action_by_production: '' },
          { re_sample: false, action_by_production: '' },
          { re_stir: false, action_by_production: ''},
          { re_filter: false, action_by_production: '' },
          { re_pack: false, action_by_production: '' },
          { other: '', action_by_production: ''}
        ],
      },
      isCreate: true,
      validations_errors: []
    }
  }

  export default {
    name: 'UpdateQcTestWorkOrderPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id, formulation_type, method, data, formulation_id) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.isCreate = method === 'create'
          this.formulation_type = formulation_type
          this.formulation_id = formulation_id
          this.id = id
          if(method === 'update') {
            await Object.assign(this.form, data)
            this.form.status = data.status === 'Approved by QC' ? 'approved' : 'rejected'
          }
          if(this.form.rejected_data.length === 0) {
            this.form.rejected_data = this.rejected_data
          }
          await this.fetchQcTestGuide()
          this.open = true;
        } catch (error) {

        }
      },
      async onClickCreateQcTest() {
        const vue = this;
        this.$vs.loading();
        try {
          if (this.form.status === 'approved') {
            delete this.form.rejected_data
          }
          if(this.isCreate) {
            await ManufacturingRepository.createWorkOrderQcTest(this.id, this.form);
            this.showSuccessMessage('WO QC Test added!');
          } else {
            await ManufacturingRepository.updateWorkOrderQcTest(this.id, this.form.id ,this.form);
            this.showSuccessMessage('WO QC Test updated!');
          }
          this.open = false;
          await vue.$emit('refreshData')
        } catch (e) {

          this.$vs.loading.close();
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async fetchQcTestGuide() {
        try {
          const { data } = (await FormulationRepository.details(this.formulation_id)).data
          if(data.q_c_quide) {
            this.q_c_quide = data.q_c_quide
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      generateErrors() {
        this.validations_errors = [];
        
        const fieldRanges = {
          specific_gravity_20: ['sg_from', 'sg_to'],
          ph: ['ph_from', 'ph_to'],
          refractive_index_20: ['ri_from', 'ri_to'],
          brix: ['brix_from', 'brix_to'],
        };

        for (const field of Object.keys(fieldRanges)) {
          const [fromKey, toKey] = fieldRanges[field];
          if (this.q_c_quide[fromKey] && this.q_c_quide[toKey] && this.form[field]) {
            const fieldValue = Number(this.form[field]);
            if (fieldValue < Number(this.q_c_quide[fromKey]) || fieldValue > Number(this.q_c_quide[toKey])) {
              this.validations_errors.push({ field, error: true });
            }
          }
        }
    }
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }
  .qc-test-guide-text {
    color: coral;
    font-weight: bold ;
    margin-left: 5px;
  }
</style>
